module.exports = __webpack_public_path__ + "img/knots_logo_large.d669c121.png";